interface Props {
  audioReady: boolean;
  audioEnabled: boolean;
  onToggleAudio: () => void;
}

export function AudioSection({ audioReady, audioEnabled, onToggleAudio }: Props) {
  return (
    <>
      <h2>Audio</h2>
      <div className="audio-toggle">
        <button onClick={onToggleAudio}>
          {audioReady ? (audioEnabled ? "Mute" : "Unmute") : "Start audio"}
        </button>
        <span className="muted" style={{ fontSize: 11 }}>
          {audioReady ? (audioEnabled ? "Live" : "Silent") : "Click to start"}
        </span>
      </div>
    </>
  );
}
